import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import WrapPage from '@/components/base/Layout/wrap';
import Pagination from '@/components/base/Pagination';
import ListHeader from '@/components/base/Layout/ListHeader';
import { PAGE_SIZE } from '@/constants/DApp';
import getDAppService from '@/api/dapp';
import refreshStore from '@/store/Refresh';
import { observer } from 'mobx-react-lite';
import DAppMiniCard from '@/components/combined/DAppMiniCard';
import Loading from 'react-loading';
import EmptyList from '@/components/combined/EmptyList';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var dappService = getDAppService();
var StyledDAppBox = styled.section.withConfig({
    displayName: "dapp__StyledDAppBox",
    componentId: "sc-1peghpf-0"
})([
    "display:grid;grid-template-columns:repeat(7,176px);grid-template-rows:repeat(3,195px);row-gap:20px;column-gap:20px;.dapp-item{border-radius:4px;background:#fff;padding:24px;}"
]);
var DApps = function() {
    var ref4 = useState([]), dapps = ref4[0], setDApps = ref4[1];
    var ref1 = useState(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = useState(1), pos = ref2[0], setpos = ref2[1];
    var ref3 = useState(0), total = ref3[0], setTotal = ref3[1];
    var refresh = refreshStore.refresh;
    var getDApps = useCallback(function() {
        setLoading(true);
        dappService.getDAppList({
            pos: (pos - 1) * PAGE_SIZE,
            limit: PAGE_SIZE
        }).then(function(response) {
            var ref = (response === null || response === void 0 ? void 0 : response.Result) || {}, _ListData = ref.ListData, ListData = _ListData === void 0 ? [] : _ListData, _TotalNum = ref.TotalNum, TotalNum = _TotalNum === void 0 ? 0 : _TotalNum;
            setDApps(ListData);
            setTotal(TotalNum);
        }).finally(function() {
            return setLoading(false);
        });
    }, [
        pos
    ]);
    var paginationOption = useMemo(function() {
        return {
            current: pos,
            pageSize: PAGE_SIZE,
            total: total,
            onPageChange: function(current) {
                return setpos(current);
            }
        };
    }, [
        total,
        pos
    ]);
    useEffect(function() {
        if (refresh) {
            getDApps();
        }
    }, [
        refresh
    ]);
    useEffect(function() {
        return getDApps();
    }, [
        pos
    ]);
    return(/*#__PURE__*/ _jsx(ListHeader, {
        title: "DApps",
        desc: "DApps",
        total: total,
        children: /*#__PURE__*/ _jsx("div", {
            children: loading ? /*#__PURE__*/ _jsx("div", {
                className: "w-full h-[600px] flex items-center justify-center",
                children: /*#__PURE__*/ _jsx(Loading, {
                    type: "cubes",
                    height: 60,
                    width: 60,
                    color: "#9ca0b2"
                })
            }) : !dapps || !dapps.length ? /*#__PURE__*/ _jsx(EmptyList, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(StyledDAppBox, {
                        children: dapps.map(function(item, i) {
                            /*#__PURE__*/ return _jsx(DAppMiniCard, {
                                url: item === null || item === void 0 ? void 0 : item.IconUrl,
                                name: item.Symbol,
                                chainid: item.ID,
                                address: item.Address,
                                confirmed: item.TxnStatus === 'Confirme'
                            }, item.Symbol);
                        })
                    }),
                    total > PAGE_SIZE && /*#__PURE__*/ _jsx(Pagination, _objectSpread({
                        className: "mt-[32px]"
                    }, paginationOption))
                ]
            })
        })
    }));
};
export default WrapPage(observer(DApps));
